import axios from '@/libs/api.request'

// 根据一级类别获取产品数据列表
export const getSolutionTypeList = (params) => {
    return axios.request({
        url: 'solution_type',
        method: 'get',
        params: params
    })
}

// 根据类别id 获取解决案例列表数据
export const getSolutionList = (params) => {
    return axios.request({
        url: 'solution',
        method: 'get',
        params: params
    })
}

// 根据类别id 获取解决案例详情
export const getSolutionDetails = (params) => {
    return axios.request({
        url: `solution/${params.id}`,
        method: 'get'
    })
}

// 获取预览接口数据
export const getPreviewDetails = (params) => {
    return axios.request({
        url: `/admin/preview/${params.id}`,
        method: 'get'
    })
}
